//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const TotalMatchedFundsWidget = ({ count }: { count: number }) => {
  return <StatCard title='Total Matched Funds' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default TotalMatchedFundsWidget;
